export enum FeedbackMessageType {
  SUCCESS = 'success',
  FAIL = 'fail',
  ERROR = 'err',
  INFO = 'info.',
}
